import React from 'react';
import SearchIcon from "@material-ui/icons/Search";

const SearchField = ({ 
  searchTerm, 
  onSearchChange, 
  searchProgress = 0, 
  classes 
}) => {
  return (
    <div className={classes.searchContainer}>
      <div 
        className={classes.customSearchField}
        style={{
          "--progress-width": `${searchProgress}%`
        }}
      >
        <div 
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: `${searchProgress}%`,
            backgroundColor: "rgba(0, 123, 255, 0.1)",
            transition: "width 0.1s ease-out",
            zIndex: 0,
            borderRadius: "6px",
          }}
        />
        <SearchIcon style={{ fontSize: 18, color: "#54606F", position: "relative", zIndex: 1 }} />
        <input
          type="text"
          placeholder="Субсчет, контрагент, субконто или ИНН"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ position: "relative", zIndex: 1 }}
        />
      </div>
    </div>
  );
};

export default SearchField;